import { createCallStrategy } from '@varos/call-core';
import { createWebRTCCallAdapter } from '@varos/call-webrtc';
import { getInstructions } from './presetConstant';
export function createCallPreset(config) {
    const adapter = createWebRTCCallAdapter({
        client: config.client,
        model: 'gpt-4o-realtime-preview-2025-06-03',
        voice: 'ash',
        connectionTimeoutMs: 10000,
        session: {
            voice: 'ash',
            inputAudioFormat: 'pcm16',
            turnDetection: {
                type: 'server_vad',
                silenceDurationMs: 1500,
            },
        },
        logLevel: 'info',
        stunTestMode: config.stunTestMode ?? false,
        debugIceServers: config.debugIceServers,
    });
    const strategy = createCallStrategy({
        adapter,
        autoStart: config.autoStart ?? true,
        getInstructions,
    });
    return {
        adapter,
        call: strategy,
    };
}
//# sourceMappingURL=presetProvider.js.map